module.exports = __webpack_public_path__ + "static_pc/img/wx2.24b65c1d.png";